import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: "easeOut" }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const SectionHeading = ({ eyebrow, title, description, dark = false, align = "left" }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <p className={`text-sm uppercase tracking-[0.2em] font-bold mb-4 ${dark ? "text-igold" : "text-brand"}`}>
        {eyebrow}
      </p>
    )}
    <h2 className={`text-3xl lg:text-4xl font-bold tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>
      {title}
    </h2>
    {description && (
      <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? "text-sky-100/80" : "text-slate-600"}`}>
        {description}
      </p>
    )}
  </Reveal>
);
